//import "./safetyforms.css";
import { useContext, useEffect, useState } from "react";
import "react-dropdown/style.css";
import { FaBuilding, FaCalendar, FaFilter, FaMapMarkerAlt, FaSearch, FaUser } from "react-icons/fa";
import { BlackButton, LightButton } from "./Buttons";
import { DropdownContainer, DropdownContent } from "./Dropdown";
import FormDatePicker from "./FormDatePicker";
import FormSelectCrewMember from "./FormSelectCrewMember";
import FormSelectCustomer from "./FormSelectCustomer";
import FormSelectSafetyFormFilter from "./FormSelectSafetyFormFilter";
import Row from "./Row";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useDispatch } from "react-redux";
import { fetchForemanFormReport } from "../common/slices/document";
import { ErrorContext } from "../ErrorContext";
import { toast } from "react-toastify";


const FormSafetyFormExport = ({ locationId }) => {
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch()
    const errorContext = useContext(ErrorContext);


    const { handleSubmit, watch, control, formState: { isValid, isSubmitting, errors } } = useForm({
        defaultValues: {
            locationId,
            startDate: moment().startOf('month').startOf('day').toDate(),
            endDate: moment().endOf('day').toDate()
        }
    })
    const fieldProps = { control, errors }

    useEffect(() => {
        const hideDropDown = () => setVisible(false);
        window.addEventListener('click', hideDropDown);
        return () => window.removeEventListener('click', hideDropDown);
    }, [])

    const startDate = watch("startDate");
    const endDate = watch("endDate");

    const onSubmit = async (values) => {
        try {
            await dispatch(fetchForemanFormReport({
                locationId: values.locationId,
                startDate: values.startDate.toISOString(),
                endDate: values.endDate.toISOString(),
            }))
            toast.success("Foreman form report generation in progress.  You will be notified when it is completed.")
            setVisible(false);
        } catch (ex) {
            console.log('failed to generate foreman report', ex);
            errorContext.setError({ errorMessage: "Failed to generate foreman form report", forSupport: ex.message })
        }
    }

    return (
        <DropdownContainer onClick={(e) => e.stopPropagation()}>
            <LightButton onClick={(e) => { e.stopPropagation(); setVisible(!visible); }}>
                Export Report
            </LightButton>
            <DropdownContent style={{ display: visible ? 'flex' : 'none', flexDirection: 'column', padding: '1rem', minWidth: '600px', gap: '1rem' }}>
                <Row>
                    <FormDatePicker {...fieldProps} name="startDate" label="Start Date" placeholder="Select start date" maxDate={endDate} startDate={startDate} endDate={endDate} rules={{ required: true }} />
                    <FormDatePicker {...fieldProps} name="endDate" label="End Date" placeholder="Select end date" minDate={startDate} startDate={startDate} endDate={endDate} rules={{ required: true }} />
                </Row>
                <BlackButton onClick={handleSubmit(onSubmit)} disabled={isSubmitting || !isValid} style={{ alignSelf: 'flex-start' }}>Export</BlackButton>
            </DropdownContent>
        </DropdownContainer>
    )
}

export default FormSafetyFormExport;